import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import SalesTaxPDF from "./SalesTaxPDF";

const TaxBillReceipt = () => (
  <PDFViewer height={"1000"} width={"100%"}>
    <SalesTaxPDF />
  </PDFViewer>
);

export default TaxBillReceipt;
